import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { AccessManager } from '@services/managers/access.manager';
import { switchMap, tap } from 'rxjs/operators';

@Component({
  templateUrl: './user-bi-reports-header.component.html',
  standalone: false
})
export class UserBiReportsHeaderComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private accessManager = inject(AccessManager);
  private destroyRef = inject(DestroyRef);

  public globalBIReportLabel: string = 'LABEL.DEFAULT_GLOBAL_BI_REPORT';

  /**
   * Set global Power BI report's label according to its name (variable passed in url parameter).
   */
  public ngOnInit(): void {
    this.route.firstChild.params.pipe(
      switchMap(params => {
        return this.accessManager.userBiReports$.pipe(
          tap(userBiReports => {
            const selectedUserBiReport = userBiReports.find(userReport => userReport.id === params.id);
            this.globalBIReportLabel = selectedUserBiReport.name;
          })
        );
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }
}
